module.exports = __webpack_public_path__ + "img/140.12e0a1b9.jpg";